import { useGraphQLQuery } from '@opengov/bnp-core';
import { IPublicationFooterSettings } from '@opengov/stories-shared/types';

import { graphql } from '../../../../../gql-generated/hasura';
import {
  GetPublicationFooterSettingsForOnlinePublicationQuery,
  GetPublicationFooterSettingsForOnlinePublicationQueryVariables
} from '../../../../../gql-generated/hasura/graphql';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { useToast } from '../../../Toast/context/useToast.context';

import {
  PublicationFooterSettingsKeyParams,
  setupOnlinePublicationQueryKeys
} from './setupOnlinePublicationQueryKeys';

const GetPublicationFooterSettingsForOnlinePublicationDocument = graphql(`
  query GetPublicationFooterSettingsForOnlinePublication($entityId: Int!, $publicationId: uuid!) {
    publicationFooterSettings(
      where: { publication: { entityId: { _eq: $entityId } }, publicationId: { _eq: $publicationId } }
    ) {
      id
      publicationId
      backgroundColors
      fontColors
      mediaLinks
    }
  }
`);

export type UsePublicationFooterSettingsParams = PublicationFooterSettingsKeyParams | null;

export function usePublicationFooterSettings(
  params: UsePublicationFooterSettingsParams,
  errorMessage: string
) {
  const { toggleToast } = useToast();

  return useGraphQLQuery<
    GetPublicationFooterSettingsForOnlinePublicationQuery,
    GetPublicationFooterSettingsForOnlinePublicationQueryVariables,
    IPublicationFooterSettings | null
  >({
    queryKey: params
      ? setupOnlinePublicationQueryKeys.publicationFooterSettings(params)
      : ([...setupOnlinePublicationQueryKeys.all, 'publicationFooterSettings', 'disabled'] as const),
    document: GetPublicationFooterSettingsForOnlinePublicationDocument,
    url: HASURA_SERVICE_URL,
    variables: params
      ? { entityId: params.entityId, publicationId: params.publicationId }
      : { entityId: 0, publicationId: '' },
    options: {
      enabled: params !== null,
      onError: () => {
        toggleToast({ title: errorMessage, severity: 'error' });
      },
      select: (data: GetPublicationFooterSettingsForOnlinePublicationQuery): IPublicationFooterSettings | null => {
        const row = data.publicationFooterSettings?.[0];
        return row ? (row as unknown as IPublicationFooterSettings) : null;
      }
    }
  });
}
